import script from "./PageHouses.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHouses.vue?vue&type=script&setup=true&lang=js"

import "./PageHouses.vue?vue&type=style&index=0&id=4b3e1864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3e1864"]])

export default __exports__